<div class="exclusion-modal">
  <div class="modal-header">
    <div class="header-content">
      <h2>Select Exclusion Reason</h2>
      <p class="measure-title">{{ measureTitle }}</p>
    </div>
    <button mat-icon-button (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <p class="instructions">
      Select the exclusion reason that applies to this measure. Only one exclusion can be claimed per measure.
    </p>

    <mat-radio-group [(ngModel)]="selectedExclusionId" class="exclusion-list">
      @for (exclusion of exclusions; track exclusion.exclusionId) {
        <mat-radio-button [value]="exclusion.exclusionId" class="exclusion-option">
          <div class="exclusion-text">{{ exclusion.description }}</div>
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>

  <div class="modal-footer">
    <button mat-button (click)="cancel()">CANCEL</button>
    @if (selectedExclusionId) {
      <button mat-button color="warn" (click)="removeExclusion()">
        REMOVE EXCLUSION
      </button>
    }
    <button 
      mat-raised-button 
      color="primary" 
      (click)="save()"
      [disabled]="!selectedExclusionId">
      SAVE EXCLUSION
    </button>
  </div>
</div>